<template>
  <div>
    <account-pc v-if="!$store.state.isMobile"></account-pc>
    <account-mobile v-else></account-mobile>
  </div>
</template>
<script>
import accountPc from './account.pc.vue'
import accountMobile from './account.mobile.vue'

export default {
  data () {
    return {}
  },
  components: {
    accountPc,
    accountMobile
  },
  computed: {}
}
</script>
<style scoped lang='sass'>
</style>
